import ChangeSuccessModal from './ChangeSuccessModal';

export default ChangeSuccessModal